// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
// import '@/styles/variables.scss';
import { pl, en, de } from 'vuetify/locale';

// Vuetify
import { createVuetify } from 'vuetify';

export default createVuetify({
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        variables: {}, // ✅ this property is required to avoid Vuetify crash
        colors: {
          //green: '#00ff00' // cannot use primary color names here, so use a custom color name (such as 'greenish')
          primary: '#29324c',
          // Workaround: Custom colors seem to erase default colors, so we need to include the default colors (of `light` or `dark` theme)
          secondary: '#ffffff',
          accent: '#DE1C68',
          error: '#e91e63',
          warning: '#ff9800',
          info: '#607d8b',
          success: '#8bc34a',
          buttonIcons: '#ffffff',
          background: '#fbfbfb',
        },
      },
      dark: {
        dark: true,
        variables: {}, // ✅ this property is required to avoid Vuetify crash
        colors: {
          primary: '#FFE500',
          secondary: '#0F1F31',
          accent: '#FFE500',
          buttonIcons: '#F90055',
          background: '#000',
        }
      }
    }
  },
  locale: {
    // Default language
    locale: 'pl',
    // Available translations
    messages: { en, pl, de },
  },
})